var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "baseTransparentMaskMain",
    on: {
      click: function($event) {
        if ($event.target !== $event.currentTarget) {
          return null
        }
        return _vm.consoleInfo("main click")
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }